import { ReactElement } from "react";
import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

type SkeletonVariant = "block";

const heights: Record<SkeletonVariant, string> = {
  block: "100%",
};

const S = styled.div<{ $variant?: SkeletonVariant }>`
  width: 100%;
  height: ${(p) => (p.$variant ? heights[p.$variant] : "1em")};
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    ${(p) => p.theme.background.secondary} 25%,
    ${(p) => p.theme.background.tertiary} 50%,
    ${(p) => p.theme.background.secondary} 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite linear;
`;

type SkeletonProps = {
  variant?: SkeletonVariant;
  style?: React.CSSProperties;
  className?: string;
};

export const Skeleton = ({ variant, ...rest }: SkeletonProps): ReactElement => (
  <S $variant={variant} {...rest} />
);
